<template>
    <div class="temperature-mode-container">
        <div class="mode-name-container">
            <span class="back" @click="closeTemperatureSetting"></span> <span
                class="mode-name">Temperature mode setting</span>
        </div>
        <div ref="temperatureModeContainer" class="mt-32">
            <canvas ref="temperatureCanvas" :width="canvasWidth" height="240px" >

            </canvas>

        </div>
        <div v-for="(item, index) in groupTemperatureMode" :key="index" class="mt-20">
            <div class=" diy-mode-container">
                <div @click="modifyTemperatureMode(temperatureMode.tIndex)"
                     :class="[temperatureMode.name?`diy-mode-item`:`diy-mode-item-none`,
                     temperatureMode.tIndex === selectedIndex? `selected`: `normal`]"
                     v-for="(temperatureMode,i) in item"
                >{{temperatureMode.name}}
                </div>
            </div>
        </div>


        <div class="confirm" @click="confirm">Confirm</div>
    </div>

</template>

<script>
    import TemperatureGraphView from "../repository/TemperatureGraphView"
    import bluetoothRepository from "../repository/bluetooth/BluetoothRepository"
    import deviceRepository from "../repository/store/DeviceRepository"
    import log from "../repository/log/log"
    import AppStore from "../vuex/StoreType"
    import storeRepository from "../repository/store/StoreRepository"
    import {initCanvasRatio} from "../util/util"

    export default {
        name    : "TemperatureSetting",
        props   : {
            showLine          : {
                type   : Boolean,
                default: false
            },
            temperatureData   : {
                type   : Object,
                default: () => {
                    return {}
                }
            },
            isConcentrate     : {
                type   : Boolean,
                default: false
            },
            diyTemperatureMode: {
                type   : Array,
                default: () => {
                    return []
                }
            },
            isShowChanged     : {
                type   : Boolean,
                default: false
            }
        },
        data() {
            return {
                temperatureGraphView: null,
                canvasWidth         : "300px",
                selectedIndex       : -1,
                isConfirmClosed     : false
            }
        },
        methods : {
            modifyTemperatureMode(selectIndex) {
                this.selectedIndex      = selectIndex
                const secondTemperature = this.diyTemperatureMode[selectIndex]
                let isCustomMode        = false
                if (secondTemperature.name === 'Custom') {
                    //支持自定义
                    isCustomMode = true
                }

                this.temperatureGraphView.init({
                    showLine: this.showLine,
                    isCustomMode,
                    data    : secondTemperature.secondTemperature
                })
                this.temperatureGraphView.draw()
            },
            confirm() {
                const secondTemperature = this.diyTemperatureMode[this.selectedIndex]
                if (secondTemperature) {
                    if (secondTemperature.isCustomMode) {
                        let temperature = []
                        for (let i = 0; i < secondTemperature.secondTemperature.length; i++) {
                            secondTemperature.secondTemperature[i].y = this.temperatureGraphView.originPointData[i].y
                        }

                        this.selectedConcentrateType.heatingModeList && this.selectedConcentrateType.heatingModeList.forEach(item => {
                            if (item.operatingModeName === 'Custom') {
                                let temperatureF = []
                                secondTemperature.secondTemperature.forEach(item => {
                                    temperatureF.push(parseInt(item.y))
                                })
                                item.temperature = temperatureF.join(",")
                                temperature      = item.temperature
                            }
                        })


                        deviceRepository.saveCustomDiyTemperature(this.selectedConcentrateType.id, temperature)
                    }
                    try {
                        bluetoothRepository.writeTemperatureMode(secondTemperature)

                        if (this.$store.state.oilType === 4) {
                            //修改当前选中的id
                            storeRepository.saveCurrentConcentrate(this.selectedConcentrateType)
                        }else {

                        }
                    } catch (e) {

                    }
                }
                this.isConfirmClosed = true
                this.$emit("onCloseTemperatureSetting")
            },
            closeTemperatureSetting() {
                this.$emit("onCloseTemperatureSetting")
            }
        },
        watch   : {
            isShowChanged(newValue, oldValue) {

                if (!this.isConcentrate) {
                    this.diyTemperatureMode.forEach((item, index) => {
                        if (item.name === this.currentTemperatureMode.name) {
                            for (let j = 0; j < (item.secondTemperature.length >= 6 ? 6 :item.secondTemperature.length); j++) {
                                if (item.secondTemperature[j].y !== this.currentTemperatureMode.secondTemperature[j].y) {
                                    isSame = false
                                    break
                                }
                                if (j === item.secondTemperature.length - 1) {
                                    isSame = true
                                }
                            }
                            if (isSame) {
                                this.selectedIndex = index
                            }
                        }
                    })
                    return
                }


                if (this.temperatureGraphView) {
                    this.temperatureGraphView.init({
                        showLine    : this.showLine,
                        data        : this.temperatureData.secondTemperature,
                        isCustomMode: false
                    })
                    this.temperatureGraphView.draw()
                }


                let isSame = false
                if (!newValue && !this.isConfirmClosed) { //这里是关闭, 而且不是手动关闭
                    this.selectedIndex = -1
                    this.diyTemperatureMode.forEach((item, index) => {
                        if (item.name === this.currentTemperatureMode.name && item.concentrateId === this.currentConcentrateType.id) {
                            for (let j = 0; j < item.secondTemperature.length; j++) {
                                if (item.secondTemperature[j].y !== this.currentTemperatureMode.secondTemperature[j].y) {
                                    isSame = false
                                    break
                                }
                                if (j === item.secondTemperature.length - 1) {
                                    isSame = true
                                }
                            }
                            if (isSame) {
                                this.selectedIndex = index
                            }
                        }
                    })

                    let isCustomMode = false
                    if (this.selectedIndex !== -1) {
                        const selectedMode = this.diyTemperatureMode[this.selectedIndex]
                        isCustomMode       = selectedMode.isCustomMode && isSame
                        this.temperatureGraphView.init({
                            showLine    : this.showLine,
                            data        : this.diyTemperatureMode[this.selectedIndex].secondTemperature,
                            isCustomMode: isCustomMode
                        })
                        this.temperatureGraphView.draw()
                        return
                    }
                }

                if (!newValue) { //恢复状态
                    this.isConfirmClosed = false
                }


                this.diyTemperatureMode.forEach((item, index) => {
                    if (item.name === this.currentTemperatureMode.name && item.concentrateId === this.currentConcentrateType.id) {
                        for (let j = 0; j < item.secondTemperature.length; j++) {
                            if (item.secondTemperature[j].y !== this.currentTemperatureMode.secondTemperature[j].y) {
                                isSame = false
                                break
                            }
                            if (j === item.secondTemperature.length - 1) {
                                isSame = item.name === 'Custom'
                            }
                        }
                    }
                })


                if (this.temperatureGraphView) {
                    this.temperatureGraphView.init({
                        showLine    : this.showLine,
                        data        : this.temperatureData.secondTemperature,
                        isCustomMode: isSame
                    })
                    this.temperatureGraphView.draw()
                }


            }
        },
        computed: {

            selectedConcentrateType() {
                return this.$store.state.selectedConcentrateType
            },

            currentConcentrateType() {
                return this.$store.state.currentConcentrateType
            },

            currentTemperatureMode() {
                return this.temperatureData
            },
            groupTemperatureMode() {
                const diyTemperatureMode   = this.diyTemperatureMode
                const groupTemperatureMode = []
                let groupData              = []
                var i                      = 0
                let isSame                 = false
                this.selectedIndex         = -1
                diyTemperatureMode.forEach((item, index) => {
                    item.tIndex = i++
                    //判断是否是相同的一个模式，判断名字和温度

                    if (item.name === this.currentTemperatureMode.name &&  this.currentConcentrateType &&  item.concentrateId === this.currentConcentrateType.id) {
                        for (let j = 0; j < item.secondTemperature.length; j++) {
                            if (item.secondTemperature[j].y !== this.currentTemperatureMode.secondTemperature[j].y) {
                                break
                            }
                            if (j === item.secondTemperature.length - 1) {
                                this.selectedIndex = index
                            }
                        }
                    }

                    groupData.push(item)
                    if (groupData.length % 4 === 0) {
                        groupTemperatureMode.push(groupData)
                        groupData = []
                    }
                })
                groupTemperatureMode.push(groupData)

                const idle = 4 - groupData.length
                if (idle > 0) {
                    for (let j = 0; j < idle; j++) {
                        groupData.push("")
                    }
                }

                return groupTemperatureMode
            },

            deviceInfo() {
                return this.$store.state.deviceInfo;
            },

        },
        mounted() {
            log("setting mounted")
            const canvas = this.$refs.temperatureCanvas
            if (!this.temperatureGraphView) {
                const temperatureModeContainer           = this.$refs.temperatureModeContainer
                const temperatureModeContainerWidthValue = temperatureModeContainer.offsetWidth
                this.canvasWidth                         = `${temperatureModeContainerWidthValue}px`
                this.$nextTick(() => {
                    const temperatureModeContainer           = this.$refs.temperatureModeContainer
                    const temperatureModeContainerWidthValue = temperatureModeContainer.offsetWidth

                    if (canvas.getContext) {
                        const canvasObj = initCanvasRatio(canvas)
                        this.viewWidth  = canvasObj.width
                        this.viewHeight = canvasObj.height
                        this.ratio = canvasObj.ratio
                    }


                    this.temperatureGraphView                = new TemperatureGraphView(canvas, this.viewWidth, this.viewHeight,this.ratio)
                    let isSame                               = false
                    if (this.isConcentrate) {
                        this.diyTemperatureMode.forEach((item, index) => {
                            if (item.name === this.currentTemperatureMode.name && item.concentrateId === this.selectedConcentrateType.id) {
                                for (let j = 0; j < item.secondTemperature.length; j++) {
                                    if (item.secondTemperature[j].y !== this.temperatureData.secondTemperature[j].y) {
                                        isSame = false
                                        break
                                    }
                                    if (j === item.secondTemperature.length - 1) {
                                        this.selectedIndex = index
                                        isSame             = item.name === 'Custom'
                                    }
                                }
                            }
                        })

                    }

                    this.temperatureGraphView.init({
                        showLine    : this.showLine,
                        data        : this.temperatureData.secondTemperature,
                        isCustomMode: isSame
                    })
                    this.temperatureGraphView.draw()
                })
            } else {
                let isSame = false
                if (this.isConcentrate) {
                    this.diyTemperatureMode.forEach((item, index) => {
                        if (item.name === this.currentTemperatureMode.name && item.concentrateId === this.selectedConcentrateType.id) {
                            for (let j = 0; j < item.secondTemperature.length; j++) {
                                if (item.secondTemperature[j].y !== this.temperatureData.secondTemperature[j].y) {
                                    isSame = false
                                    break
                                }
                                if (j === item.secondTemperature.length - 1) {
                                    isSame = item.name === 'Custom'
                                }
                            }
                        }
                    })

                }

                this.temperatureGraphView.init({
                    showLine    : this.showLine,
                    data        : this.temperatureData.secondTemperature,
                    isCustomMode: isSame
                })
                this.temperatureGraphView.draw()
            }
        },
        created() {
            log("1232131")
        }
    }
</script>

<style lang="scss" scoped>
    .temperature-mode-container {
        display: flex;
        padding: 22px;
        flex-direction: column;
        background-color: #333333;

        .mode-name-container {
            display: flex;
            color: #F6F6F6;
            flex-direction: row;
            align-items: center;

            .back {
                width: 3px;
                height: 14px;
                padding: 4px;
                margin-left: 8px;
                background-repeat: no-repeat;
                background-position: center center;
                background-size: cover;
                @include bg-image("../assets/back");
            }


            .mode-name {
                flex: 1;
                text-align: center;
                margin-right: 26px;
                font-size: 17px;
            }
        }

        .diyTemperature {

        }

        .diy-mode-container {
            display: flex;
            flex-direction: row;
            align-items: center;

            .diy-mode-item {
                flex: 1;
                font-size: 8px;
                text-align: center;
                margin: 2px;
                padding-top: 12px;
                padding-bottom: 12px;
                color: #F6F6F6;
                border-radius: 16px;

                &.selected {
                    color: #ED6C0F;
                    border: 1px solid #ED6C0F;
                }

                &.normal {
                    color: #F6F6F6;
                    border: 1px solid #F6F6F6;
                }
            }

            .diy-mode-item-none {
                flex: 1;
            }
        }
    }

    .canvasPadding {
        padding-top: 30px;
    }


    .confirm {
        margin-top: 20px;
        background: white;
        padding: 10px;
        text-align: center;
        border-radius: 10px;
        color: #000;
    }

</style>